import React from "react";
import PropTypes from "prop-types";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import styles from "./main-navigation-subcategory.css";

function SubCategory({ title, submenu, show, onCategoryClick, onClose, fullRender }) {
    const hasSubMenus = submenu.menus && submenu.menus.length > 0;
    const hasTrendMenus = submenu.trend_menus && submenu.trend_menus.length > 0;
    const hasLinks = submenu.links && submenu.links.length > 0;

    function renderSubCategory(submenu, type) {
        return submenu[type].map((menu) => (
            <SubCategory
                key={menu.display_name}
                title={menu.display_name}
                submenu={menu}
                fullRender={true}
            />
        ));
    }

    return (
        <>
            <div
                className={classnames(styles.subCategoryContainer, {
                    [styles.show]: show,
                })}
            >
                <button type="button" className={styles.subcategoryTitle} onClick={onClose}>
                    {!fullRender && (
                        <SVGIcon
                            className={styles.menuItemBigChevron}
                            name="arrow-icon"
                            flip={true}
                        />
                    )}
                    {title}
                </button>

                {hasSubMenus &&
                    submenu.menus.map((menu) => (
                        <button
                            key={menu.display_name}
                            type="button"
                            className={styles.menuItem}
                            onClick={() => {
                                onCategoryClick(menu);
                            }}
                        >
                            {menu.display_name}
                            {!fullRender && (
                                <SVGIcon className={styles.menuItemChevron} name="arrow-icon" />
                            )}
                        </button>
                    ))}

                {hasLinks &&
                    submenu.links.map((link) => {
                        const isSaleLink = link.is_sale;

                        return (
                            <a
                                key={link.url}
                                className={classnames(styles.menuItem, {
                                    [styles.saleLink]: isSaleLink,
                                })}
                                href={link.url}
                            >
                                {isSaleLink && (
                                    <SVGIcon
                                        className={classnames(styles.saleTag, styles.saleLink)}
                                        name="tag"
                                    />
                                )}
                                {link.text}
                            </a>
                        );
                    })}
                {hasTrendMenus && (
                    <>
                        {submenu.trend_menus.map((trendMenu, index) => (
                            <button
                                key={`${submenu.trend_heading}-${index}`}
                                className={styles.menuItem}
                                type="button"
                                onClick={() => {
                                    onCategoryClick(trendMenu);
                                }}
                            >
                                {trendMenu.display_name}

                                {!fullRender && (
                                    <SVGIcon className={styles.menuItemChevron} name="arrow-icon" />
                                )}
                            </button>
                        ))}
                    </>
                )}
            </div>

            {fullRender && hasSubMenus && renderSubCategory(submenu, "menus")}

            {fullRender && hasTrendMenus && renderSubCategory(submenu, "trend_menus")}
        </>
    );
}

SubCategory.propTypes = {
    title: PropTypes.string,
    submenu: PropTypes.object,
    isOpen: PropTypes.bool,
    onCategoryClick: PropTypes.func,
    onClose: PropTypes.func,
    show: PropTypes.bool,
    fullRender: PropTypes.bool,
};

export default SubCategory;
